import { requests } from "../../../../api/agent"

export default {
	create               : (params) => requests.post('/predictivePrice/create', params),
	update               : (params) => requests.post('/predictivePrice/update', params),
	delete               : (params) => requests.getWithParams('/predictivePrice/delete', params),
	restore              : (params) => requests.getWithParams('/predictivePrice/restore', params),
    getPagedAll          : (params) => requests.getWithParams('/predictivePrice/getPagedAll', params),
	getPagedAudit        : (params) => requests.getWithParams('/predictivePrice/getPagedAudit', params),
	getList              : (params) => requests.getWithParams('/predictivePrice/getList', params),
}
